import { Bar, type BarDatum, type BarSvgProps, ResponsiveBar, type ResponsiveBarSvgProps } from '@nivo/bar'

import { baseTheme, QualitativeColorOptions } from '../shared/theme'

const defaultQualitativeColors = Object.values(QualitativeColorOptions).filter(color => color !== QualitativeColorOptions.gray)

const defaultMargin = { top: 12, right: 12, bottom: 64, left: 24 }

const defaultAxisBottom = {
    tickPadding: 4,
    tickRotation: 0,
}

const defaultAxisLeft = {
    tickPadding: 4,
    tickValues: 4,
}

const defaultAstraProps = {
    theme: baseTheme,
    colors: defaultQualitativeColors,
    animate: false,
    margin: defaultMargin,
    padding: 0.3,
    innerPadding: 1,
    enableLabel: false,
    enableGridX: true,
    enableGridY: true,
    borderRadius: 0,
}

type AstraBarChartProps<D extends BarDatum> = ResponsiveBarSvgProps<D> & {
    width?: number
    height?: number
}

export const AstraResponsiveBarChart = <D extends BarDatum>({ width, height, ...props }: AstraBarChartProps<D>) => {
    const axisBottomToUse = props.axisBottom === null ? null : { ...defaultAxisBottom, ...props.axisBottom }
    const axisLeftToUse = props.axisLeft === null ? null : { ...defaultAxisLeft, ...props.axisLeft }

    if (width !== undefined && height !== undefined) {
        return <Bar {...defaultAstraProps} {...(props as BarSvgProps<D>)} width={width} height={height} axisBottom={axisBottomToUse} axisLeft={axisLeftToUse} />
    }

    return <ResponsiveBar {...defaultAstraProps} {...props} axisBottom={axisBottomToUse} axisLeft={axisLeftToUse} />
}
